// extracted by mini-css-extract-plugin
export default {"date":"rZx5R9oavpciaEvxA4bY"};